// IA Sticky Bar — toggles `is-stuck` once a `position: sticky` element is
// pinned. No sentinel: a top rootMargin equal to the sticky offset makes the
// bar clip (ratio < 1) exactly when it pins.
if (!customElements.get("ia-sticky-bar")) {
  class IaStickyBar extends HTMLElement {
    connectedCallback() {
      const top = parseInt(getComputedStyle(this).top, 10) || 0;
      this._io = new IntersectionObserver(
        ([entry]) => this.classList.toggle("is-stuck", entry.intersectionRatio < 1),
        { threshold: [1], rootMargin: `-${top + 1}px 0px 0px 0px` }
      );
      this._io.observe(this);

      this._back = this.querySelector(".ia-filter-bar__back");
      this._onBack = (event) => {
        event.preventDefault();
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
      };
      this._back?.addEventListener("click", this._onBack);
    }

    disconnectedCallback() {
      this._io?.disconnect();
      this._back?.removeEventListener("click", this._onBack);
    }
  }

  customElements.define("ia-sticky-bar", IaStickyBar);
}
